export type ToolCall = {
  id: string;
  type?: string;
  function: { name: string; arguments: string };
};

export type ConversationMessage = {
  role: string;
  content: string | unknown[] | null;
  tool_calls?: ToolCall[] | null;
  tool_call_id?: string;
  name?: string;
  reasoning_content?: string;
  reasoningContent?: string;
};

export type ConversationSummary = {
  id: string;
  userId: string;
  clientId: string | null;
  clientName: string | null;
  familyId: string | null;
  familyName: string | null;
  originFamilyName: string | null;
  source: string;
  title: string | null;
  messageCount: number;
  startedAt: string;
  updatedAt: string;
  firstUserMessage: string | null;
};

export type ConversationFile = {
  id: string;
  filename: string;
  fileType: string | null;
  fileSize: number | null;
  createdAt: string | null;
  downloadUrl: string;
};

export type ConversationDebug = {
  id: string;
  userId: string;
  userName: string | null;
  userEmail: string | null;
  clientId: string | null;
  clientName: string | null;
  familyId: string | null;
  familyName: string | null;
  originFamilyName: string | null;
  source: string;
  title: string | null;
  messageCount: number;
  startedAt: string;
  updatedAt: string;
  metadata: Record<string, unknown>;
  messages: ConversationMessage[];
};

export function messageText(content: ConversationMessage['content']): string {
  if (typeof content === 'string') {
    return content;
  }
  if (Array.isArray(content)) {
    const textBlocks = content
      .map(block =>
        block && typeof block === 'object' && 'text' in block ? String(block.text) : null,
      )
      .filter(Boolean);
    return textBlocks.length > 0 ? textBlocks.join('\n') : JSON.stringify(content, null, 2);
  }
  return '';
}

export function messagePreview(message: ConversationMessage): string {
  const text = messageText(message.content).replace(/\s+/g, ' ').trim();
  const toolNames = (message.tool_calls ?? []).map(tc => tc.function.name);
  if (toolNames.length > 0) {
    const calls = `→ ${toolNames.join(', ')}`;
    return text ? `${text.slice(0, 120)} ${calls}` : calls;
  }
  return text || '(empty)';
}

export function prettyJson(raw: string): string {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}
